import { configConstants } from '../utils/types';

export default function config(
  state = {
    loading: false,
    data: { default_home_route: '/sessions' },
    appInitialized: false
  },
  action
) {
  const actionPayload = action.payload;
  switch (action.type) {
    case configConstants.GET_CONFIG_REQUEST:
      return {
        ...state,
        loading: true
      };

    case configConstants.GET_CONFIG_SUCCESS:
      return {
        ...state,
        loading: false,
        data: actionPayload.data
      };

    case configConstants.GET_CONFIG_FAILURE:
      return {
        ...state,
        loading: false,
        error: actionPayload.error
      };

    case configConstants.APP_INITIALIZED:
      return {
        ...state,
        appInitialized: actionPayload.appInitialized
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/configReducer.js